import { css } from '@emotion/react'
import useMedia from 'use-media'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

const productLogoWrapperCss = ({ colors }) => css`
  font-weight: 500;
  letter-spacing: -0.88px;
  font-size: 28px;
  line-height: 1.2;
  margin-right: 16px;
  color: ${colors.black};
  text-decoration: none;
`

const Logo = () => {
  const isTablet = useMedia({
    minWidth: mediaQueries.BASE_SMALL_SIZE,
  })

  return (
    <a
      alt={process.env.GATSBY_PRODUCT_LABEL}
      rel="noopener noreferrer"
      href={process.env.GATSBY_PRODUCT_WEBSITE_URL}
      css={productLogoWrapperCss}
    >
      <span>{isTablet ? 'text|' : 't|'}</span>
    </a>
  )
}

export default Logo
